/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralSubscriptionsRepository = (
    options: GeneralRestApiOptions
): Types.GeneralSubscriptionsRepository => ({
    async add(params, requestOptions) {
        return options.request('/subscriptions/add', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getAll(params, requestOptions) {
        return options.request('/subscriptions/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async update(params, requestOptions) {
        return options.request('/subscriptions/update', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
